import { Expose } from "class-transformer";
import { Model } from "./model";

export class EducationLevelPreference extends Model{
  @Expose() advancedPercentage : number ;
  @Expose() beginnerPercentage : number ;
  @Expose() intermediatPercentage : number ;
}
